import React, { HTMLAttributes } from 'react';
import { IconTypes } from '../../../../utilities/icomoon-css/iconTypes';
import { TLazyIconKey } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { LocationTypes } from '../locationMap/locationTypes';
export namespace FooterTypes {
  export type TLocationType = 'single' | 'multi';
  export type TSocialIconSizeType = 'small' | 'medium' | 'large' | string;
  export type TIconsAndBgColorType = 'primary' | 'secondary' | string;

  export type TSocialIconsColorType =
    | 'white'
    | 'primary'
    | 'secondary'
    | string;
  export type TCTAButtonBgColorsType = 'accent' | string;
  export type TCTAButtonColorsType = 'cta-button-text-color' | string;
  export type TFacilityDetails = {
    facilityAddress: string;
    googleMapsUrl: string;
    facilityName: string;
    facilityLogo: TLogo;
  };
  export type TIconsType = {
    iconName: TLazyIconKey | any;
    socialIcon?: IconTypes.TName;
    iconsUrl: string;
  };

  export type TSocialIcons = {
    socialIcons: TIconsType[];
    socialIcon?: string;
  };
  export type TNavLinks = {
    navLinks: TQuickLinks[];
    contactDetails?: TContactDetails;
    labelsAndLogos: TLabelsAndLogos;
    contactDetailsFooter: TContactDetailsFooter;
    locationType?: TLocationType;
  };
  export type TCopyRights = {
    contactDetails?: TContactDetails;
    labelsAndLogos: TLabelsAndLogos;
    currentVariant: TFooterVariantModes;
  };
  export type TPoweredBy = {
    currentVariant: TFooterVariantModes;
  };

  export type TQuickLinksReachUsVariants = {
    quickLinksandReachUsData: TNavLinks;
    contactDetails: TContactDetails;
    currentVariant: TFooterVariantModes;
  };
  export type TSocialIcon = {
    iconUrl?: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
  };
  export type TSocialMediaIcons = {
    socialMediaIconsData?: TSocialIcons;
  };
  export interface IconBaseProps extends React.SVGAttributes<SVGElement> {
    children?: React.ReactNode;
    size?: string | number;
    color?: string;
    title?: string;
  }
  export type TIconType = (props: IconBaseProps) => JSX.Element;

  export type TFooterSectionSizes = {
    socialIconSizes: number;
  };
  export interface IFooterConfig extends HTMLAttributes<HTMLDivElement> {
    theme: TThemeModes;
    variant?: TFooterVariantModes;
    stateName?: string;
    cityName?: string;
    locationType: TLocationType;
    labelsAndLogos: TLabelsAndLogos;
    buttonsConfig: TButtonsConfig[];
    hours: LocationTypes.TFacilityHours;
    show: boolean;
    curlocations: LocationTypes.TLocation[];
    isHoursForAllLocationsSame: boolean;
    locations: TLocations;
    iconsConfig: TIconsConfig;
    syrasoftEmailID?: string;
    navLinks: TQuickLinks[];
    termsPrivacySiteMapAndDisclaimer: TTermsAndPrivacy[];
  }
  export type TLocations = {
    location: TLocation;
  };
  export type TLocation = {
    id: string;
    socialIcons: TIconsType[];
    contactDetails: TContactDetails;
  };
  export type TThemeModes = 'light' | 'dark';

  export type TFooterVariant = {
    contactDetails: TContactDetails;
    socialMediaIconsData?: TSocialIcons;
    quickLinksandReachUsData: TNavLinks;
    labelsLogoandCityStateNames?: TLabelsLogoandCityStateNames;
    labelsAndLogos: TLabelsAndLogos;
    termsPrivacySiteMapAndDisclaimer: TTermsAndPrivacy[];
    facilityGateHours?: IFacilityHrs;
  };
  export interface IFacilityHrs extends HTMLAttributes<HTMLDivElement> {
    show: boolean;
    curlocations: LocationTypes.TLocation[];
    isHoursForAllLocationsSame: boolean;
    locationType: TLocationType;
  }
  export type TTermsDisclamerAndSiteMap = {
    termsPrivacySiteMapAndDisclaimer: TTermsAndPrivacy[];
  };

  export type TNavLinkDropDown = {
    subLinkName: string;
    subLinkUrl: string;
  };
  export type TCTAButtons = {
    reserveButtonBgColor: TCTAButtonBgColorsType;
    reserveButtonTextColor: TCTAButtonColorsType;
    payRentButtonBgColor: TCTAButtonBgColorsType;
    payRentButtonTextColor: TCTAButtonColorsType;
  };
  export type TLabelsLogoandCityStateNames = {
    labelsAndLogos?: TLabelsAndLogos;
    locationType?: TLocationType;
    buttonsConfig: TButtonsConfig[];
  };
  export type TFooterVariantData = {
    quickLinksandReachUsData: TNavLinks;
    socialMediaIconsData: TSocialIcons;
    labelsAndLogos: TLabelsAndLogos;
    contactDetails: TContactDetails;
    termsPrivacySiteMapAndDisclaimer: TTermsAndPrivacy[];
    labelsLogoandCityStateNames?: TLabelsLogoandCityStateNames;
    facilityGateHours?: IFacilityHrs;
  };
  export type TCTAIconType = {
    name: TLazyIconKey;
    position?: 'left' | 'right';
    type: string;
    size: 16 | number;
  };
  export type TButtonsConfig = {
    label: 'Pay Rent' | 'Reserve' | string;
    url: string;
    icon: TCTAIconType;
  };
  export type TTermsAndPrivacy = {
    linkName: string;
    linkUrl: string;
    newTab: boolean;
  };
  export type TQuickLinks = {
    NavLinkText: string;
    isNavLinkDropDown: boolean;
    isGrouped?: boolean;
    linkTo: string;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    RenderAs: React.ElementType;
    newTab: boolean;
    payrentTab?: boolean;
    locationType?: TLocationType;
    navLinkDropDown: TNavLinkDropDown[];
  };
  export type TLabelsAndLogos = {
    quickLinksLabel: string;
    reachUsLabel: string;
    poweredByText: 'Powered by' | string;
    copyrightlogo: TLazyIconKey;
    facilityLogo?: string;
  };
  export type TContactDetailsFooter = {
    contactDetails: TContactDetails;
    iconsConfig: TIconsConfig;
  };
  export type TReachUsDataAddress = TReachUsData & {
    address: {
      googleMapsUrl: string;
      facilityAddress: string;
    };
  };
  export type TReachUsData = {
    reachUsDetails: TContactDetailsFooter;
  };
  export type TReachUsDataEmailAddress = TReachUsData & {
    mail: string;
  };
  export type TReachUsDataPhoneNumber = TReachUsData & {
    phoneno: string;
  };
  export type TContactDetails = {
    syrasoftEmailID: string;
    mailingAddress: string;
    emailID: string;
    phoneNumber: string;
    facilityDetails: TFacilityDetails;
  };
  export type TReachUsInfo = {
    icon: TLazyIconKey;
    locationName: string;
  };

  export type TFooterVariantModes =
    | 'footer-1'
    | 'footer-2'
    | 'footer-3'
    | 'new-footer-1' | 'esim-type';
  export type TLogoTheme = {
    lightTheme: string;
    darkTheme: string;
  };
  export type TLogo = {
    logo: TLogoTheme;
    renderAs: React.ElementType;
    altText: string;
  };
  export type TIconsConfig = {
    phoneNumberIcon: TLazyIconKey;
    emailIDIcon: TLazyIconKey;
    facilityAddressIcon: TLazyIconKey;
    mailingAddressIcon: TLazyIconKey;
  };
  export interface INewFooterReachUs extends HTMLAttributes<HTMLDivElement> {
    address: string;
    googleMapUrl: string;
    phone: string;
    emailAddress: string;
  }

  export type TReachUsIcon = {
    iconClassName: TLazyIconKey;
    label: string;
  };
}
